import { environment } from "environment";
import { Discipline, DisciplineNumber } from "../enums/discipline.enum";

/**
 * Documentation navigation targets for the React app.
 *
 * Kept self-contained on purpose: the environment branches do not all carry
 * `home-route.util.ts` / `myzpax-routes.util.ts`, so this must not depend on
 * them or the cutover fails to build where they are absent.
 */

const disciplineIds: { [key: string]: number } = {
  [Discipline.PhysicalTherapy]: DisciplineNumber.PT,
  [Discipline.OccupationalTherapy]: DisciplineNumber.OT,
  [Discipline.SpeechTherapy]: DisciplineNumber.ST,
};

export function isReactDocumentationEnabled(): boolean {
  return !!environment.enableNewReactApp;
}

/**
 * React documentation hub for a patient. The Angular route carried the
 * discipline as a path segment (`document/PT`); the React page reads a numeric
 * `discipline` query param instead. An unknown discipline is omitted, leaving
 * the React page to fall back to the user's default.
 */
export function reactDocumentationUrl(
  facilityId: string | null | undefined,
  patientId: string,
  discipline?: string | null,
): string {
  const base = `/rc/patient/${encodeURIComponent(
    facilityId ?? "",
  )}/profile/${encodeURIComponent(patientId)}/documentation`;
  const disciplineId = discipline ? disciplineIds[discipline.trim()] : undefined;
  return disciplineId ? `${base}?discipline=${disciplineId}` : base;
}
